import { ref } from "vue";

/**
 * Signal partagé (module-level) pour rafraîchir la liste des bassins.
 *
 * La liste de la sidebar (`PoolsList`) et le bouton refresh du header d'une
 * pool (`KlereoBanner`) vivent dans deux sous-arbres de composants distincts,
 * sans store commun. Ce signal permet au header de déclencher un rafraîchissement
 * de la liste (rechargement API + re-scan BLE) sans lien direct entre les deux.
 */
const refreshSignal = ref(0);

export const triggerPoolsRefresh = () => {
  refreshSignal.value++;
};

export const usePoolsRefreshSignal = () => refreshSignal;
